import { ErpDiv, ErpH3 } from './ErpHtml';
import React from 'react';
import classNames from 'classnames';

interface Props {
  title?: string;
  flush?: boolean;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const _DetailCard: React.FC<Props> = ({ title = '', flush = false, header, footer, children, className }) => {
  return (
    <ErpDiv className={classNames('min-w-0 self-start overflow-hidden rounded-lg border border-border bg-card text-card-foreground', className)}>
      {/* `header` is a ReactNode, so a falsy-but-valid value (0, '') must
          still render the header block. */}
      {(title || header != null) && (
        <ErpDiv className="border-b border-border px-3 py-2.5">
          {title && <ErpH3 className="text-sm font-semibold">{title}</ErpH3>}
          {header}
        </ErpDiv>
      )}
      <ErpDiv className={flush ? 'p-0' : 'p-3'}>
        {children}
      </ErpDiv>
      {footer && (
        <ErpDiv className="border-t border-border px-3 py-2.5">
          {footer}
        </ErpDiv>
      )}
    </ErpDiv>
  );
};

export const DetailCard = React.memo(_DetailCard);
